import { V400M } from './schermen';
import { PAX } from './pax';
import type { Scherm, Toestel } from './types';

/**
 * De toestellen die de emulator kent.
 *
 * Twee families, en dat onderscheid is de hele reden dat dit bestand bestaat:
 * de MENU'S lopen grotendeels gelijk op, maar het SCHERMBEELD verschilt
 * volledig. Wie een klant door een menu praat met het verkeerde beeld voor
 * ogen, wijst naar een knop die er niet zo uitziet — en dat kost precies het
 * telefoontje dat deze emulator moest besparen.
 *
 * De volgorde hieronder is de volgorde op de overzichtspagina.
 */
export const TOESTELLEN: readonly Toestel[] = [V400M, PAX];

const PER_SLUG = new Map<string, Toestel>();
for (const t of TOESTELLEN) {
  PER_SLUG.set(t.slug, t);
  // Aliassen: wie een A920 in handen heeft tikt /emulator/a920 en komt goed
  // uit, ook al heet de emulator 'pax'.
  for (const a of t.aliassen) PER_SLUG.set(a, t);
}

export const toestelVan = (slug: string): Toestel | null => PER_SLUG.get(slug.toLowerCase()) ?? null;

export const isToestelSlug = (slug: string): boolean => PER_SLUG.has(slug.toLowerCase());

/** Alle slugs en aliassen — voor de routecontrole en de verificatiescripts. */
export const ALLE_SLUGS: readonly string[] = [...PER_SLUG.keys()];

/**
 * Eén scherm van een toestel.
 *
 * Onder noUncheckedIndexedAccess levert een Record<string, …> altijd
 * `| undefined`. Binnen één toestelbestand is `to` op compileertijd
 * gecontroleerd, dus dat kán hier niet misgaan; de terugval is er voor een
 * scherm-id dat van BUITEN komt — een deeplink met een oude naam erin.
 */
export function schermVan(toestel: Toestel, id: string): Scherm {
  const s = toestel.schermen[id];
  if (s) return s;
  const wortel = toestel.schermen[toestel.wortel];
  if (wortel) return wortel;
  return { type: 'msg', title: '', lines: [] };
}

export const heeftScherm = (toestel: Toestel, id: string): boolean =>
  Object.hasOwn(toestel.schermen, id);
